import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://lcbixbruitqhctmmswtg.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxjYml4YnJ1aXRxaGN0bW1zd3RnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgxNTQyOTIsImV4cCI6MjA2MzczMDI5Mn0.7oY-u795_OzAZ-wfeAciXNuBOPG5BardQe3eBcA63Lk";
const supabase = createClient(supabaseUrl, supabaseKey);
export default supabase;
